import React, { useMemo } from 'react';

import { useUnit } from 'effector-react';
import { useSnackbar } from 'notistack';
import { Navigate, Route, Routes as RoutesComponent } from 'react-router-dom';

import { AdministrationAuditLog } from './AuditLog';
import { EditInvestbox } from './EditInvestbox';
import { Faq } from './Faq';
import { Investboxes } from './Investboxes';
import { Mailer } from './Mailer';
import { Promotions } from './Promotions';
import { Strategies } from './Strategies';
import { StrategyDetails } from './StrategyDetails';
import { Users } from './Users';
import { Navigation } from '../../components/Navigation';
import { User$ } from '../../effector/user';
import { UserRoles } from '../../types/userRoles';
import { checkPermissions, UserAction } from '../../utils/permissions';
import { PrivateRoute } from '../PrivateRoute';
import {
  PAGE_ADMINISTRATION,
  PAGE_ADMINISTRATION_INVESTBOXES,
  PAGE_ADMINISTRATION_STRATEGIES,
  PAGE_ADMINISTRATION_STRATEGY_DETAILS,
  PAGE_ADMINISTRATION_USERS,
  PAGE_ADMINISTRATION_FAQ,
  PAGE_ADMINISTRATION_MAILER,
  PAGE_ADMINISTRATION_PROMOTIONS,
  PAGE_ADMINISTRATION_AUDIT_LOG,
} from '../Routes';

export const Administration: React.FC = () => {
  const user = useUnit(User$);
  const { enqueueSnackbar } = useSnackbar();

  const navigation = useMemo(() => {
    if (user) {
      const items = [
        {
          name: 'Пользователи',
          path: PAGE_ADMINISTRATION_USERS,
          action: UserAction.administrationUsers,
        },
        {
          name: 'Стратегии',
          path: PAGE_ADMINISTRATION_STRATEGIES,
          action: UserAction.administrationStrategies,
        },
        {
          name: 'Управление стратегией',
          path: PAGE_ADMINISTRATION_STRATEGY_DETAILS,
          action: UserAction.administrationManagement,
        },
        {
          name: 'Копилки',
          path: PAGE_ADMINISTRATION_INVESTBOXES,
          action: UserAction.administrationInvestbox,
        },
        {
          name: 'Mailer',
          path: PAGE_ADMINISTRATION_MAILER,
          action: UserAction.administrationCb,
        },
        {
          name: 'FAQ',
          path: PAGE_ADMINISTRATION_FAQ,
          action: UserAction.administrationCb,
        },
        {
          name: 'Журнал событий',
          path: PAGE_ADMINISTRATION_AUDIT_LOG,
          action: UserAction.administration,
        },
        {
          name: 'Акции',
          path: PAGE_ADMINISTRATION_PROMOTIONS,
          action: UserAction.administrationPromotions,
        },
      ];

      return items.filter((item) => checkPermissions(user.role, item.action));
    }
    return [];
  }, [user]);

  const redirectUrl = useMemo(() => {
    if (user?.role !== UserRoles.Developer) {
      return PAGE_ADMINISTRATION_USERS;
    }
    return PAGE_ADMINISTRATION_STRATEGIES;
  }, [user]);

  return (
    <div className="administration">
      <div className="administration__navigation">
        <Navigation items={navigation} basePath={PAGE_ADMINISTRATION} />
      </div>
      <div className="administration__content">
        <RoutesComponent>
          <Route
            path={PAGE_ADMINISTRATION_STRATEGIES}
            element={<PrivateRoute userAction={UserAction.administrationStrategies} component={Strategies} />}
          />
          <Route
            path={PAGE_ADMINISTRATION_USERS}
            element={<PrivateRoute userAction={UserAction.administrationUsers} component={Users} />}
          />
          <Route
            path={PAGE_ADMINISTRATION_INVESTBOXES}
            element={<PrivateRoute userAction={UserAction.administrationInvestbox} component={Investboxes} />}
          />
          <Route
            path={`${PAGE_ADMINISTRATION_INVESTBOXES}/:id`}
            element={<EditInvestbox notify={(msg: string) => enqueueSnackbar(msg)} />}
          />
          <Route
            path={`${PAGE_ADMINISTRATION_STRATEGY_DETAILS}/:strategyId?`}
            element={<PrivateRoute userAction={UserAction.administrationManagement} component={StrategyDetails} />}
          />
          <Route
            path={`${PAGE_ADMINISTRATION_FAQ}/*`}
            element={<PrivateRoute userAction={UserAction.administrationFaq} component={Faq} />}
          />
          <Route
            path={`${PAGE_ADMINISTRATION_MAILER}/*`}
            element={<PrivateRoute userAction={UserAction.administrationFaq} component={Mailer} />}
          />
          <Route
            path={PAGE_ADMINISTRATION_AUDIT_LOG}
            element={<PrivateRoute userAction={UserAction.administration} component={AdministrationAuditLog} />}
          />
          <Route
            path={PAGE_ADMINISTRATION_PROMOTIONS}
            element={<PrivateRoute userAction={UserAction.administrationPromotions} component={Promotions} />}
          />
          <Route path="*" element={<Navigate replace to={`${PAGE_ADMINISTRATION}/${redirectUrl}`} />} />
        </RoutesComponent>
      </div>
    </div>
  );
};
